import { render, staticRenderFns } from "./LoadVehicle.vue?vue&type=template&id=ffd0fb74"
import script from "./LoadVehicle.vue?vue&type=script&lang=js"
export * from "./LoadVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports